import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { AwardIcon } from 'lucide-react';
export function FocusSection() {
  const ref = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const contentY = useTransform(scrollYProgress, [0, 1], ['30px', '-30px']);
  return <section ref={ref} className="py-32 bg-navy text-weiss relative overflow-hidden" data-id="element-44">
      {/* Floating Gold Orbs */}
      <div className="gold-glow-orb w-80 h-80 top-0 left-0 opacity-10" data-id="element-45" />
      <div className="gold-glow-orb w-96 h-96 bottom-0 right-10 opacity-5" style={{
      animationDelay: '-7s'
    }} data-id="element-46" />
      <div className="gold-glow-orb w-64 h-64 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-10" style={{
      animationDelay: '-3s'
    }} data-id="element-47" />

      <div className="max-w-5xl mx-auto px-6 text-center relative z-10" data-id="element-48">
        <motion.div style={{
        y: contentY,
        willChange: 'transform'
      }} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center" data-id="element-49">
          <AwardIcon className="w-12 h-12 text-gold mb-8" data-id="element-50" />

          <h2 className="text-3xl md:text-5xl font-poppins font-bold mb-8 uppercase tracking-tight gold-shimmer" data-id="element-51">
            FOCUS Top-Mediziner Empfehlung
          </h2>

          <div className="w-24 h-px bg-gold mb-10" data-id="element-52" />

          <p className="text-lg md:text-xl text-weiss/70 font-lora leading-relaxed mb-12 max-w-3xl" data-id="element-53">
            Die drei Inhaber von edel & weiss:{' '}
            <strong className="text-weiss font-bold" data-id="element-54">
              Dr. Thomas Schwenk, Dr. Markus Striegel, und Dr. Johanna Herzog
              M.Sc.
            </strong>{' '}
            werden in der FOCUS-Top-Mediziner-Empfehlungsliste als führende
            Experten geführt.
          </p>

          <div className="flex flex-wrap justify-center gap-4 text-sm md:text-base text-weiss/80 font-poppins" data-id="element-55">
            <span className="px-6 py-3 border border-weiss/20 rounded-full hover:border-gold hover:text-gold transition-colors" data-id="element-56">
              Ästhetische Zahnheilkunde
            </span>
            <span className="px-6 py-3 border border-weiss/20 rounded-full hover:border-gold hover:text-gold transition-colors" data-id="element-57">
              Kieferorthopädie
            </span>
            <span className="px-6 py-3 border border-weiss/20 rounded-full hover:border-gold hover:text-gold transition-colors" data-id="element-58">
              CMD
            </span>
            <span className="px-6 py-3 border border-weiss/20 rounded-full hover:border-gold hover:text-gold transition-colors" data-id="element-59">
              Sportzahnmedizin
            </span>
            <span className="px-6 py-3 border border-weiss/20 rounded-full hover:border-gold hover:text-gold transition-colors" data-id="element-60">
              Parodontologie
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}